import { motion } from 'motion/react'
import { ArrowRight } from 'lucide-react'
import { CALENDLY_URL } from './constants'
import { useLanguage } from '@/i18n/LanguageContext'

export default function CtaBand() {
  const { t } = useLanguage()

  return (
    <section className="relative px-4 py-10 sm:px-6">
      <motion.div
        initial={{ opacity: 0, y: 32 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true, margin: '-60px' }}
        transition={{ duration: 0.7, ease: 'easeOut' }}
        className="mx-auto flex max-w-5xl flex-col items-center gap-6 rounded-[2.5rem] border-2 border-dashed border-terracotta/60 bg-terracotta/10 px-8 py-12 text-center md:flex-row md:justify-between md:text-left"
      >
        <div>
          <h2 className="font-display text-3xl font-medium italic text-ink md:text-4xl">
            {t.ctaBand.title}
          </h2>
          <p className="mt-2 text-sm text-ink/60">
            {t.ctaBand.subtitle}
          </p>
        </div>
        <motion.a
          href={CALENDLY_URL}
          target="_blank"
          rel="noopener noreferrer"
          whileHover={{ scale: 1.05 }}
          whileTap={{ scale: 0.97 }}
          transition={{ type: 'spring', stiffness: 400, damping: 20 }}
          className="inline-flex shrink-0 items-center gap-3 whitespace-nowrap rounded-full bg-terracotta px-8 py-4 text-lg font-semibold text-cream shadow-lg shadow-terracotta/30"
        >
          {t.common.ctaLabel}
          <ArrowRight className="h-5 w-5" />
        </motion.a>
      </motion.div>
    </section>
  )
}
